import './GaugeLabelsWrapper.css';
export var labelsContainer = '_4kek940-2-0-1';